<template>
    <div class="historial-formulario-pcc">

        <!-- =============================================
             ENCABEZADO
        ============================================== -->

        <div class="page-header">

            <div class="d-flex align-items-center">

                <div class="header-icon">
                    <i
                        class="fas fa-clipboard-check"
                        style="color: #9fc4f0;"
                    ></i>
                </div>

                <div class="ml-4">

                    <h1 class="titulo-principal">
                        Formulario PCC - Historial de Cambios
                    </h1>

                    <div class="subtitulo-principal">
                        Guía(s): {{ formulario.numero_guia }}
                    </div>

                    <div
                        v-if="romaneroNombre"
                        class="usuario-info"
                    >
                        <i class="fas fa-check-circle text-success"></i>

                        Romanero: {{ romaneroNombre }}
                    </div>

                </div>

            </div>

        </div>


        <!-- =============================================
             INFORMACIÓN DEL FORMULARIO
        ============================================== -->

        <div class="seccion-card mb-5">

            <div class="seccion-header">

                <div class="d-flex align-items-center">

                    <div class="seccion-icon">
                        <i class="fas fa-info-circle text-primary"></i>
                    </div>

                    <div class="ml-3">

                        <div class="seccion-titulo">
                            Información del formulario
                        </div>

                        <div class="seccion-subtitulo">
                            Datos generales asociados al formulario
                        </div>

                    </div>

                </div>

            </div>


            <div class="info-grid">

                <!-- FECHA -->

                <div class="info-col">

                    <div class="info-box">

                        <div class="info-icon">
                            <i class="fas fa-calendar fa-sm text-primary"></i>
                        </div>

                        <div>

                            <div class="info-label">
                                FECHA
                            </div>

                            <div class="info-value">
                                {{ formatearFechaSolo(formulario.fecha) }}
                            </div>

                        </div>

                    </div>

                </div>


                <!-- FOLIO -->

                <div class="info-col">

                    <div class="info-box">

                        <div class="info-icon">
                            <i class="fas fa-file-alt fa-sm text-primary"></i>
                        </div>

                        <div>

                            <div class="info-label">
                                FOLIO
                            </div>

                            <div class="info-value">
                                {{ formulario.folio || '-' }}
                            </div>

                        </div>

                    </div>

                </div>


                <!-- PATENTE -->

                <div class="info-col">

                    <div class="info-box">

                        <div class="info-icon">
                            <i class="fas fa-truck fa-sm text-primary"></i>
                        </div>

                        <div>

                            <div class="info-label">
                                PATENTE
                            </div>

                            <div class="info-value">
                                {{ formulario.patente || '-' }}
                            </div>

                        </div>

                    </div>

                </div>


                <!-- CANTIDAD BINS -->

                <div class="info-col">

                    <div class="info-box">

                        <div class="info-icon">
                            <i class="fas fa-th fa-sm text-primary"></i>
                        </div>

                        <div>

                            <div class="info-label">
                                CANTIDAD DE BINS
                            </div>

                            <div class="info-value">
                                {{ formulario.cantidad_bins || 0 }}
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>


        <!-- =============================================
             ESTADO ACTUAL
        ============================================== -->

        <div class="seccion-card mb-5">

            <div class="seccion-header">

                <div class="d-flex align-items-center">

                    <div class="seccion-icon">
                        <i class="fas fa-clipboard-check text-primary"></i>
                    </div>

                    <div class="ml-3">

                        <div class="seccion-titulo">
                            Estado actual del formulario
                        </div>

                        <div class="seccion-subtitulo">
                            Estado actual de las validaciones
                        </div>

                    </div>

                </div>

            </div>


            <div class="estado-lista">

                <div class="estado-item">

                    <div>
                        <strong>
                            Mortalidad - Guía de Despacho
                        </strong>
                    </div>

                    <span
                        class="estado-chip"
                        :class="claseEstado(formulario.mortalidad_guia_despacho)"
                    >
                        {{
                            mostrarValor(
                                formulario.mortalidad_guia_despacho
                            )
                        }}
                    </span>

                </div>


                <div class="estado-item">

                    <div>
                        <strong>
                            Mortalidad - Declaración Jurada
                        </strong>
                    </div>

                    <span
                        class="estado-chip"
                        :class="claseEstado(formulario.mortalidad_declaracion_jurada)"
                    >
                        {{
                            mostrarValor(
                                formulario.mortalidad_declaracion_jurada
                            )
                        }}
                    </span>

                </div>


                <div class="estado-item">

                    <div>

                        <strong>
                            Mortalidad - CAM
                        </strong>

                        <div class="campo-descripcion">
                            Certificado de Autorización de Movimiento
                        </div>

                    </div>

                    <span
                        class="estado-chip"
                        :class="claseEstado(formulario.mortalidad_cam)"
                    >
                        {{
                            mostrarValor(
                                formulario.mortalidad_cam
                            )
                        }}
                    </span>

                </div>

            </div>

        </div>


        <!-- =============================================
             OBSERVACIONES
        ============================================== -->

        <div class="seccion-card mb-5">

            <div class="seccion-header">

                <div class="d-flex align-items-center">

                    <div class="seccion-icon">
                        <i class="fas fa-comment text-primary"></i>
                    </div>

                    <div class="ml-3">

                        <div class="seccion-titulo">
                            Observaciones actuales
                        </div>

                        <div class="seccion-subtitulo">
                            Información adicional del formulario
                        </div>

                    </div>

                </div>

            </div>


            <div class="observaciones-box">

                {{
                    formulario.observaciones
                        ? formulario.observaciones
                        : 'Sin observaciones'
                }}

            </div>

        </div>


        <!-- =============================================
             HISTORIAL
        ============================================== -->

        <div class="seccion-card historial-card">

            <div class="seccion-header">

                <div class="d-flex align-items-center">

                    <div class="seccion-icon">

                        <i
                            class="fas fa-history"
                            style="color: #2d76c2;"
                        ></i>

                    </div>

                    <div class="ml-3">

                        <div class="seccion-titulo">
                            Historial de cambios
                        </div>

                        <div class="seccion-subtitulo">
                            Listado de modificaciones realizadas al formulario
                        </div>

                    </div>

                </div>

            </div>


            <!-- SIN HISTORIAL -->

            <div
                v-if="!historial || historial.length === 0"
                class="sin-historial"
            >

                <i
                    class="fas fa-history fa-2x"
                    style="color: #bdbdbd;"
                ></i>

                <div class="mt-3">
                    No existen cambios registrados para este formulario.
                </div>

            </div>


            <!-- HISTORIAL -->

            <div
                v-else
                class="timeline"
            >

                <div
                    v-for="item in historial"
                    :key="item.id"
                    class="timeline-item"
                >

                    <div class="timeline-left">

                        <div class="timeline-dot"></div>

                        <div class="timeline-line"></div>

                    </div>


                    <!-- FECHA -->

                    <div class="timeline-date">

                        <strong>
                            {{ fechaHistorial(item.created_at) }}
                        </strong>

                        <div class="timeline-hour">
                            {{ horaHistorial(item.created_at) }}
                        </div>

                    </div>


                    <!-- CARD CAMBIO -->

                    <div class="historial-item-card">


                        <!-- CABECERA -->

                        <div class="historial-item-header">

                            <div class="d-flex align-items-center">

                                <div class="avatar-usuario">

                                    {{ inicialesUsuario(item) }}

                                </div>


                                <div class="ml-3">

                                    <div class="usuario-nombre">

                                        {{ nombreUsuario(item) }}

                                    </div>

                                    <div class="usuario-subtitulo">

                                        {{ descripcionUsuario(item) }}

                                    </div>

                                </div>

                            </div>


                            <span class="cantidad-cambios">

                                {{ cantidadCambios(item) }}

                                {{
                                    cantidadCambios(item) === 1
                                        ? 'cambio'
                                        : 'cambios'
                                }}

                            </span>

                        </div>


                        <!-- TABLA -->

                        <div class="tabla-wrapper">

                            <table class="tabla-cambios">

                                <thead>

                                    <tr>

                                        <th>
                                            CAMPO
                                        </th>

                                        <th>
                                            VALOR ANTERIOR
                                        </th>

                                        <th>
                                            VALOR NUEVO
                                        </th>

                                    </tr>

                                </thead>


                                <tbody>

                                    <tr
                                        v-for="(cambio, campo) in item.cambios_formateados"
                                        :key="campo"
                                    >

                                        <td>
                                            {{ nombreCampo(campo) }}
                                        </td>


                                        <!-- ANTERIOR -->

                                        <td>

                                            <span
                                                v-if="esEstado(cambio.anterior)"
                                                class="estado-chip"
                                                :class="claseEstado(cambio.anterior)"
                                            >
                                                {{
                                                    mostrarValor(
                                                        cambio.anterior
                                                    )
                                                }}
                                            </span>


                                            <span v-else>
                                                {{
                                                    mostrarValor(
                                                        cambio.anterior
                                                    )
                                                }}
                                            </span>

                                        </td>


                                        <!-- NUEVO -->

                                        <td>

                                            <span
                                                v-if="esEstado(cambio.nuevo)"
                                                class="estado-chip"
                                                :class="claseEstado(cambio.nuevo)"
                                            >
                                                {{
                                                    mostrarValor(
                                                        cambio.nuevo
                                                    )
                                                }}
                                            </span>


                                            <span v-else>
                                                {{
                                                    mostrarValor(
                                                        cambio.nuevo
                                                    )
                                                }}
                                            </span>

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>


<script>
export default {

    name: 'FormularioPCCHistorial',


    props: {

        formulario: {
            type: Object,
            required: true
        },


        historial: {
            type: Array,
            default: function () {
                return [];
            }
        },


        guias: {
            type: Array,
            default: function () {
                return [];
            }
        }

    },


    data: function () {

        return {

            nombresCampos: {

                subproducto:
                    'Subproducto',

                subproducto_listado_maestro:
                    'Subproducto - Listado maestro',

                subproducto_rest_mercado_dj:
                    'Subproducto - Restricción mercado DJ',

                subproducto_guia_despacho:
                    'Subproducto - Guía de despacho',

                subproducto_guia_despacho_accion_correctiva:
                    'Acción correctiva - Guía de despacho',

                subproducto_declaracion_jurada:
                    'Subproducto - Declaración jurada',

                subproducto_declaracion_jurada_accion_correctiva:
                    'Acción correctiva - Declaración jurada',

                subproducto_cumple_restriccion_horas_traslado:
                    'Cumple restricción horas traslado',

                mortalidad_guia_despacho:
                    'Mortalidad - Guía de despacho',

                mortalidad_guia_despacho_accion_correctiva:
                    'Acción correctiva - Mortalidad guía despacho',

                mortalidad_declaracion_jurada:
                    'Mortalidad - Declaración Jurada',

                mortalidad_declaracion_jurada_accion_correctiva:
                    'Acción correctiva - Mortalidad declaración jurada',

                mortalidad_cam:
                    'Mortalidad - CAM',

                mortalidad_cam_accion_correctiva:
                    'Acción correctiva - Mortalidad CAM',

                observaciones:
                    'Observaciones',

                folio:
                    'Folio',

                cantidad_bins:
                    'Cantidad de bins',

                check_romanero:
                    'Validación Romanero',

                romanero_id:
                    'Romanero',

                check_jefe_trazabilidad:
                    'Validación Jefe de Trazabilidad',

                jefe_trazabilidad_id:
                    'Jefe de Trazabilidad',

                check_jefe_pac:
                    'Validación Jefe PAC',

                jefe_pac_id:
                    'Jefe PAC',

                fecha_firma_romanero:
                    'Fecha firma Romanero',

                fecha_firma_jefe_trazabilidad:
                    'Fecha firma Jefe de Trazabilidad',

                fecha_firma_jefe_pac:
                    'Fecha firma Jefe PAC'

            }

        };

    },


    computed: {

        guiasTexto: function () {

            if (!this.guias || this.guias.length === 0) {
                return '-';
            }

            return this.guias.join(' - ');

        },


        romaneroNombre: function () {

            if (!this.formulario) {
                return null;
            }

            if (
                this.formulario.romanero &&
                this.formulario.romanero.name
            ) {
                return this.formulario.romanero.name;
            }

            if (this.formulario.romanero_nombre) {
                return this.formulario.romanero_nombre;
            }

            return null;

        }

    },


    methods: {


        nombreCampo: function (campo) {

            if (this.nombresCampos[campo]) {
                return this.nombresCampos[campo];
            }

            return campo;

        },


        cantidadCambios: function (item) {

            if (!item || !item.cambios) {
                return 0;
            }

            return Object.keys(item.cambios).length;

        },


        nombreUsuario: function (item) {

            if (!item || !item.usuario) {
                return 'Usuario desconocido';
            }

            if (item.usuario.name) {
                return item.usuario.name;
            }

            if (item.usuario.nombre) {

                var nombre = item.usuario.nombre;

                if (item.usuario.apellido) {
                    nombre += ' ' + item.usuario.apellido;
                }

                return nombre;

            }

            return 'Usuario desconocido';

        },


        descripcionUsuario: function (item) {

            if (!item || !item.usuario) {
                return 'Usuario';
            }

            if (item.usuario.email) {
                return item.usuario.email;
            }

            return 'Usuario';

        },


        inicialesUsuario: function (item) {

            var nombre = this.nombreUsuario(item);

            if (!nombre) {
                return '?';
            }

            var partes = nombre.split(' ');

            var iniciales = '';

            if (partes.length > 0) {
                iniciales += partes[0].charAt(0);
            }

            if (partes.length > 1) {
                iniciales += partes[1].charAt(0);
            }

            return iniciales.toUpperCase();

        },


        mostrarValor: function (valor) {

            if (
                valor === null ||
                valor === undefined ||
                valor === ''
            ) {
                return '-';
            }

            if (
                valor === true ||
                valor === 1 ||
                valor === '1'
            ) {
                return 'Sí';
            }

            if (
                valor === false ||
                valor === 0 ||
                valor === '0'
            ) {
                return 'No';
            }

            return valor;

        },


        esEstado: function (valor) {

            return (
                valor === 'CUMPLE' ||
                valor === 'NO CUMPLE'
            );

        },


        claseEstado: function (valor) {

            if (valor === 'CUMPLE') {
                return 'estado-cumple';
            }

            if (valor === 'NO CUMPLE') {
                return 'estado-no-cumple';
            }

            return 'estado-default';

        },


        fechaHistorial: function (fecha) {

            if (!fecha) {
                return '-';
            }

            var date = new Date(fecha);

            if (isNaN(date.getTime())) {
                return fecha;
            }

            return date.toLocaleDateString(
                'es-CL',
                {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }
            );

        },


        horaHistorial: function (fecha) {

            if (!fecha) {
                return '';
            }

            var date = new Date(fecha);

            if (isNaN(date.getTime())) {
                return '';
            }

            return date.toLocaleTimeString(
                'es-CL',
                {
                    hour: '2-digit',
                    minute: '2-digit'
                }
            );

        },


        formatearFechaSolo: function (fecha) {

            if (!fecha) {
                return '-';
            }

            if (typeof fecha === 'string') {

                var fechaSimple = fecha.substring(0, 10);

                var partes = fechaSimple.split('-');

                if (partes.length === 3) {

                    return (
                        partes[2] +
                        '/' +
                        partes[1] +
                        '/' +
                        partes[0]
                    );

                }

            }

            return fecha;

        }

    }

};
</script>


<style scoped>

.historial-formulario-pcc {
    padding: 20px;
    background: #f4f6fa;
    min-height: 100vh;
}


/* =============================================
   HEADER
============================================= */

.page-header {
    margin: -20px -20px 25px -20px;
    padding: 22px 30px;
    background: #1d3154;
    color: #ffffff;
}

.header-icon {
    width: 48px;
    height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10px;

    font-size: 25px;

    background: rgba(255,255,255,0.10);
}

.titulo-principal {
    margin: 0;
    color: white;
    font-size: 22px;
    font-weight: 700;
}

.subtitulo-principal {
    margin-top: 4px;

    font-size: 14px;

    color: #c9d5e7;
}

.usuario-info {
    margin-top: 7px;

    font-size: 12px;

    color: #dce5f2;
}


/* =============================================
   CARDS
============================================= */

.seccion-card {
    margin-bottom: 25px;

    background: #ffffff;

    border: 1px solid #dce3ee;

    border-radius: 12px;

    overflow: hidden;
}

.seccion-header {
    padding: 18px 20px;
}

.seccion-icon {
    width: 38px;
    height: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 9px;

    background: #edf3fb;
}

.seccion-titulo {
    font-size: 16px;

    font-weight: 700;

    color: #24364f;
}

.seccion-subtitulo {
    margin-top: 3px;

    font-size: 12px;

    color: #718096;
}


/* =============================================
   INFORMACION
============================================= */

.info-grid {
    display: grid;

    grid-template-columns: repeat(4, 1fr);

    gap: 15px;

    padding: 0 20px 20px 20px;
}

.info-box {
    min-height: 70px;

    display: flex;
    align-items: center;

    padding: 15px;

    border: 1px solid #dfe6ef;

    border-radius: 10px;

    background: #fafbfd;
}

.info-icon {
    width: 38px;
    height: 38px;

    min-width: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 8px;

    background: #edf3fb;
}

.info-label {
    font-size: 10px;

    font-weight: 600;

    letter-spacing: .5px;

    color: #7c8798;
}

.info-value {
    margin-top: 4px;

    font-size: 14px;

    font-weight: 700;

    color: #263950;
}


/* =============================================
   ESTADOS
============================================= */

.estado-lista {
    border-top: 1px solid #edf0f4;
}

.estado-item {
    min-height: 62px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 15px;

    padding: 15px 20px;

    color: #2e4057;

    border-bottom: 1px solid #edf0f4;
}

.estado-item:last-child {
    border-bottom: none;
}

.campo-descripcion {
    margin-top: 4px;

    font-size: 11px;

    color: #7b8798;
}


/* =============================================
   CHIPS
============================================= */

.estado-chip {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    padding: 5px 11px;

    border-radius: 20px;

    font-size: 11px;
    font-weight: 700;

    white-space: nowrap;

    border: 1px solid;
}

.estado-cumple {
    color: #2e7d32;

    background: #edf7ee;

    border-color: #2e7d32;
}

.estado-no-cumple {
    color: #c62828;

    background: #ffebee;

    border-color: #c62828;
}

.estado-default {
    color: #6c757d;

    background: #f3f4f6;

    border-color: #adb5bd;
}

.cantidad-cambios {
    display: inline-flex;

    align-items: center;

    padding: 5px 10px;

    border-radius: 20px;

    font-size: 11px;
    font-weight: 700;

    color: #1976d2;

    border: 1px solid #1976d2;

    white-space: nowrap;
}


/* =============================================
   OBSERVACIONES
============================================= */

.observaciones-box {
    min-height: 80px;

    margin: 0 20px 20px 20px;

    padding: 16px;

    border: 1px solid #dce3ee;

    border-radius: 9px;

    background: #fafbfd;

    color: #526276;

    white-space: pre-line;
}


/* =============================================
   SIN HISTORIAL
============================================= */

.sin-historial {
    padding: 50px;

    text-align: center;

    color: #8a96a8;
}


/* =============================================
   TIMELINE
============================================= */

.timeline {
    padding: 10px 25px 10px 25px;
}

.timeline-item {
    position: relative;

    display: grid;

    grid-template-columns: 30px 100px 1fr;

    column-gap: 15px;

    margin-bottom: 25px;
}

.timeline-left {
    position: relative;

    display: flex;

    justify-content: center;
}

.timeline-dot {
    width: 13px;
    height: 13px;

    margin-top: 16px;

    border-radius: 50%;

    background: #2d76c2;

    z-index: 2;
}

.timeline-line {
    position: absolute;

    top: 29px;
    bottom: -28px;

    width: 2px;

    background: #d9e3ef;
}

.timeline-item:last-child .timeline-line {
    display: none;
}

.timeline-date {
    padding-top: 12px;

    font-size: 13px;

    color: #34475f;
}

.timeline-hour {
    margin-top: 3px;

    color: #2d76c2;

    font-weight: 700;
}


/* =============================================
   CARD DEL HISTORIAL
============================================= */

.historial-item-card {
    border: 1px solid #dce4ee;

    border-radius: 10px;

    overflow: hidden;

    background: #ffffff;
}

.historial-item-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 15px;

    padding: 15px 18px;

    border-bottom: 1px solid #edf0f4;
}

.avatar-usuario {
    width: 38px;
    height: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    background: #2d76c2;

    color: white;

    font-size: 13px;

    font-weight: 700;
}

.usuario-nombre {
    font-size: 14px;

    font-weight: 700;

    color: #2c3f56;
}

.usuario-subtitulo {
    margin-top: 3px;

    font-size: 11px;

    color: #8490a1;
}


/* =============================================
   TABLA
============================================= */

.tabla-wrapper {
    padding: 10px 15px 15px 15px;

    overflow-x: auto;
}

.tabla-cambios {
    width: 100%;

    border-collapse: collapse;

    border: 1px solid #e0e6ee;
}

.tabla-cambios th {
    padding: 11px 14px;

    text-align: left;

    font-size: 10px;

    letter-spacing: .6px;

    color: #68768a;

    background: #f6f8fb;

    border-bottom: 1px solid #e0e6ee;
}

.tabla-cambios td {
    padding: 12px 14px;

    font-size: 13px;

    color: #37485d;

    border-bottom: 1px solid #edf0f4;
}

.tabla-cambios tr:last-child td {
    border-bottom: none;
}


/* =============================================
   RESPONSIVE
============================================= */

@media (max-width: 1100px) {

    .info-grid {
        grid-template-columns: repeat(2, 1fr);
    }

}


@media (max-width: 768px) {

    .historial-formulario-pcc {
        padding: 10px;
    }

    .page-header {
        margin: -10px -10px 20px -10px;
        padding: 20px;
    }

    .info-grid {
        grid-template-columns: 1fr;
    }

    .timeline {
        padding: 10px;
    }

    .timeline-item {
        grid-template-columns: 20px 1fr;

        column-gap: 10px;
    }

    .timeline-left {
        grid-row: 1 / span 2;
    }

    .timeline-date {
        grid-column: 2;

        padding-top: 0;

        margin-bottom: 10px;
    }

    .historial-item-card {
        grid-column: 2;
    }

    .titulo-principal {
        font-size: 18px;
    }

    .historial-item-header {
        align-items: flex-start;
    }

    .estado-item {
        align-items: flex-start;
        flex-direction: column;
    }

}

</style>